import * as React from 'react';

import { AppContainer } from 'app/pages/app';

type Props = {
  component: React.ComponentType;
};

/** A page inside the app's frame (footer, login check) */
export const DefaultLayout = ({ component: Component }: Props) => (
  <AppContainer>
    <Component />
  </AppContainer>
);
